import { render, staticRenderFns } from "./business_info.vue?vue&type=template&id=3e9a023c&scoped=true"
import script from "./business_info.vue?vue&type=script&lang=js"
export * from "./business_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a023c",
  null
  
)

export default component.exports